import classNames from 'classnames'
import Link from 'components/link'

import {
  CHECKLIST,
  HOME,
  REGISTRY,
  GIFT_TRACKER,
  LEFT_NAV_ADD_ITEM_SCREEN_VIEW_EVENT,
} from 'registry/constants'

import {
  registryChecklistPath,
  registryHomePath,
  registryPath,
  giftTrackerPath,
  registryAddItemsPath,
} from 'lib/urls'

import useFeatureFlag from 'shared/hooks/useFeatureFlag/useFeatureFlag'
import { ACTIVE_NAV_SECTION_EVENT } from 'shared/constants'

import css from './BabyRegistryActions.scss'

interface BabyRegistryActionsProps {
  activeNav: string
  registryUrlSlug?: string
}

export const BabyRegistryActions = ({
  activeNav,
  registryUrlSlug,
}: BabyRegistryActionsProps) => {
  const isInWebAddItemsExperiment =
    useFeatureFlag('24b_ex_dayzero_web_add_items', 'control').flagValue ===
    'variation1'

  return (
    <ul className={css.navMenu}>
      <li>
        <Link
          className={classNames(
            css.navLink,
            activeNav == HOME ? css.active : null
          )}
          routerVersion={4}
          to={registryHomePath}
          onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, HOME)}
        >
          <div className={classNames(css.navIcon, css.iconHome)} />
          <span>{isInWebAddItemsExperiment ? 'Home' : 'Build Registry'}</span>
        </Link>
      </li>
      <li>
        <Link
          className={classNames(
            css.navLink,
            activeNav === REGISTRY ? css.active : null
          )}
          routerVersion={4}
          to={registryPath(registryUrlSlug)}
          onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, REGISTRY)}
        >
          <div className={classNames(css.navIcon, css.iconRegistry)} />
          <span>View Registry</span>
        </Link>
      </li>
      {isInWebAddItemsExperiment && (
        <li>
          <Link
            className={css.navLink}
            routerVersion={4}
            // use url to navigate out of react router context
            url={`${registryAddItemsPath}?entry_point=${LEFT_NAV_ADD_ITEM_SCREEN_VIEW_EVENT}`}
            onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, null)}
          >
            <div className={classNames(css.navIcon, css.iconAddItems)} />
            <span>Add Items</span>
          </Link>
        </li>
      )}
      <li>
        <Link
          className={classNames(
            css.navLink,
            activeNav === CHECKLIST ? css.active : null
          )}
          routerVersion={4}
          to={registryChecklistPath}
          onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, CHECKLIST)}
        >
          <div className={classNames(css.navIcon, css.iconChecklist)} />
          <span>Checklist</span>
        </Link>
      </li>
      <li>
        <Link
          className={classNames(
            css.navLink,
            activeNav === GIFT_TRACKER ? css.active : null
          )}
          routerVersion={4}
          to={giftTrackerPath()}
          onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, null)}
        >
          <div className={classNames(css.navIcon, css.iconGiftTracker)} />
          <span>Gift Tracker</span>
        </Link>
      </li>
    </ul>
  )
}
